import { Theme, color, rem, token, radius } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('tooltip');
const theme = new Theme(tag);

export const styles = [
  css`
    :where(.tooltip) {
      --offset: ${rem(8)};

      border: 0;
      margin: unset;
      max-inline-size: ${rem(400)};
      opacity: 0;
      overflow: visible;
      padding: unset;
      position: absolute;
      transition: opacity ${token('transition-duration-fast')};

      ${theme.props([
        ['padding', 'padding', rem(8, 16)],
        ['border-radius', 'border-radius', radius('small')],
        ['background-color', 'primary-background-color', color('blue', 600)],
        ['color', 'color', color('white')],
      ])}
    }

    :where(.arrow) {
      block-size: 8px;
      inline-size: 8px;
      position: absolute;
      transform: rotate(45deg);

      ${theme.props([
        ['background-color', 'primary-background-color', color('blue', 600)],
      ])}
    }

    :host([variant='secondary']) :where(.tooltip) {
      ${theme.props([
        ['background-color', 'secondary-background-color', color('grey', 600)],
      ])}

      &::after {
        border-color: ${color('grey', 600)};
      }
    }
    :host([variant='secondary']) :where(.arrow) {
      ${theme.props([
        ['background-color', 'secondary-background-color', color('grey', 600)],
      ])}
    }

    :host([variant='error']) :where(.tooltip) {
      ${theme.props([
        ['background-color', 'error-background-color', color('red', 600)],
      ])}

      &::after {
        border-color: ${color('red', 600)};
      }
    }
    :host([variant='error']) :where(.arrow) {
      ${theme.props([
        ['background-color', 'error-background-color', color('red', 600)],
      ])}
    }

    .tooltip:popover-open {
      opacity: 1;

      &[hide] {
        opacity: 0;
      }
    }

    @starting-style {
      .tooltip:popover-open {
        opacity: 0;
      }
    }

    .tooltip::before {
      content: '';
      display: block;
      position: absolute;
    }

    :host([placement='top']) .tooltip::before {
      block-size: var(--offset);
      inset-block-end: calc(-1 * var(--offset));
      inset-inline: 0;
    }

    :host([placement='bottom']) .tooltip::before {
      block-size: var(--offset);
      inset-block-start: calc(-1 * var(--offset));
      inset-inline: 0;
    }

    :host([placement='left']) .tooltip::before {
      inline-size: var(--offset);
      inset-block-end: 0;
      inset-block-start: 0;
      inset-inline-end: calc(-1 * var(--offset));
    }

    :host([placement='right']) .tooltip::before {
      inline-size: var(--offset);
      inset-block-end: 0;
      inset-block-start: 0;
      inset-inline-start: calc(-1 * var(--offset));
    }
  `,
];
